import api from '../../api/client';
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import config from "../../config";
import { usePermissions } from "../../permissions";
import DashDefault from "./DashDefault";
import EmployeeDashboard from "./Employees";
import HRDashboard from "./HRDashboard";
import AccountantDashboard from "./AccDashboard";
import ManagerDash from "./ManagerDash";
import FarmDashboard from "./FarmDashboard";

const Dashboard = () => {
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;
  const { createPermission, deletePermission, editPermission } =
    usePermissions();
  const [userRoles, setUserRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const account = useSelector((state) => state.account.user);

  useEffect(() => {
    const fetchUserRoles = async () => {
      try {
        const response = await api.get(`/roles`);
        const rolesData = response.data;
        const options = rolesData.map((role) => ({
          value: role.id,
          label: role.name,
        }));
        setUserRoles(options);
      } catch (error) {
} finally {
        setLoading(false); // ✅ Done loading whether success or error
      }
    };

    fetchUserRoles();
  }, [account, apiUrl]);

  // 👇 Wait until roles are loaded
  if (loading) {
    return <div>Loading...</div>; // or a spinner
  }

  const EMPLOYEE_ROLE_ID = account.is_admin;
  const logedRole = userRoles.find((o) => o.value === EMPLOYEE_ROLE_ID)?.label;
  const isEmployee = logedRole && logedRole.toLowerCase().includes("employee");
  const isHR = logedRole && logedRole.toLowerCase().includes("hr");
  const isAcc = logedRole && logedRole.toLowerCase().includes("accountant");
  const isManager = logedRole && logedRole.toLowerCase().includes("manager");
  const isSupervisor =
    logedRole && logedRole.toLowerCase().includes("supervisor");
  const isAdmin = logedRole && logedRole.toLowerCase().includes("admin");
return isEmployee ? (
    <EmployeeDashboard />
//   ) : isHR ? (
//     <HRDashboard />
//   ) : isAcc ? (
//     <AccountantDashboard />
//   ) : isManager ? (
//     <ManagerDash />
  ) : isAdmin || isSupervisor || isAcc || isManager ? (
    <DashDefault />
  ) : (
    // <AccountantDashboard />
    <FarmDashboard />
  );
};

export default Dashboard;


